import { AccountCircleOutlined, AssessmentOutlined, BadgeOutlined, ContactSupportOutlined, DashboardCustomizeOutlined, DarkModeOutlined, DirectionsCarFilledOutlined, DisplaySettingsOutlined, Diversity2Outlined, ExitToAppOutlined, ExpandLess, ExpandMore, HailOutlined, HelpOutlineOutlined, HistoryEduOutlined, LayersOutlined, LibraryAddOutlined, LocationCityOutlined, LogoutOutlined, ManageAccountsOutlined, MapOutlined, MenuOpenOutlined, MenuOutlined, NotificationsActiveOutlined, NotificationsNoneOutlined, PersonOutlineOutlined, PinOutlined, QueuePlayNextOutlined, ReduceCapacityOutlined, SearchOutlined, SettingsOutlined, TapAndPlayOutlined, TouchAppOutlined, TuneOutlined, WbSunnyOutlined } from "@mui/icons-material";
import { Navigate, Route, Routes, useLocation, useNavigate } from "react-router-dom";

import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import { Badge, Box, CardMedia, Collapse, Divider, Drawer, IconButton, List, ListItem, ListItemButton, ListItemIcon, ListItemText, styled, Switch, SwitchProps, Toolbar, Tooltip, Typography } from "@mui/material";
import { Toast } from "primereact/toast";

import { useRecoilValue, useSetRecoilState } from "recoil";
import { DriverAlertCustomerSummaryType, SelectedParametersSimpleType, SelectedParametersType, UserType, VehicleAlertCustomerSummaryType } from "../../types/types";
import { selectedCustomerToManagerMapAtom, userAtom } from "../../atoms/atoms";
import { useCookies } from "react-cookie";

import VehiclePage from "../privateApp/vehicles";
import CommandPage from "../privateApp/commands";
import AccessPage from "../privateApp/accesses";
import SettingsPage from "../privateApp/settings";
import ProfilePage from "../privateApp/profile";
import ReportPage from "../privateApp/reports";
import NotFoundPage from "../publicRoutes/notfound";
import CustomerPage from "./customers";
import SecretaryPage from "./secretaries";
import DepartmentPage from "./departments";
import DevicePage from "./devices";
import IdentifierPage from "./Identifiers";
import DriverPage from "../privateApp/drivers";
import HomePage from "./home";
import DashMapPage from "../privateApp/home";
import CustomerHelpPage from "./customerHelp";
import LogListPage from "./customerHelp/options/LogListComponent";
import SelectParametersModal from "../privateApp/home/components/SelectParametersModal";
import { MENUS_ITENS, PROFILE_ACESSES } from "../../consts/consts";
import logoutUser from "../../resources/Api/authenticator/logoutUser";
import findAllVehicleAlerts from "../../resources/Api/vehiclealert/findAllVehicleAlerts";
import findAllDriverAlerts from "../../resources/Api/driveralert/findAllDriverAlerts";
import DriverAlertCard from "../../components/DriverAlertCard";
import VehicleAlertCard from "../../components/VehicleAlertCard";
import { useThemeMode } from "../../components/DarkModeWrapper";
import TransparencyPortalLinkButton from "../../components/TransparencyPortalLinkButton";
import { useIntroTour } from "../../components/introTour/useIntroTour";
import { buildIntroTourSteps, menuTourId, tourAnchor } from "../../components/introTour/introTourSteps";
import findTransparencyPortalLinkAvailable from "../../resources/Api/transparencyPortal/findTransparencyPortalLinkAvailable";

/**
 * PrivateRoutes - Creates private routes do access options
 * @component
 */
const PrivateRoutes = ({
    isHiddenMenu,
    isFixedMenu,
    isMenuOverlayOpen,
    showGeofences,
    showCarsFilter,
    showMapChanger,
    showMapSearch,
    filterActions,
}: {
    isHiddenMenu: boolean;
    isFixedMenu: boolean;
    isMenuOverlayOpen: boolean;
    showGeofences: boolean;
    showCarsFilter: boolean;
    showMapChanger: boolean;
    showMapSearch: boolean;
    filterActions: Array<{ name: string; action: (value: boolean) => void }>;
}) => {
    const currentUser = useRecoilValue<UserType>(userAtom);
    const currentLocation = useLocation();
    const isTechnician = currentUser.accessProfile.id === Number(PROFILE_ACESSES.TECHNICIAN);
    const technicianPaths = ["/devices", "/identifiers", "/commands", "/vehicles", "/reports", "/help-desk", "/user-profile"];

    if (isTechnician && !technicianPaths.includes(currentLocation.pathname)) {
        return <Navigate to="/devices" replace />;
    }

    return <>
        <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/tracker" element={
                <DashMapPage
                    isHiddenMenu={isHiddenMenu}
                    isFixedMenu={isFixedMenu}
                    isMenuOverlayOpen={isMenuOverlayOpen}
                    showGeofences={showGeofences}
                    showCarsFilter={showCarsFilter}
                    showMapChanger={showMapChanger}
                    showMapSearch={showMapSearch}
                    actions={filterActions}
                />}
            />
            <Route path="/customers" element={<CustomerPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/customers/secretaries" element={<SecretaryPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/customers/secretaries/departments" element={<DepartmentPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/customers/secretaries/departments/drivers" element={<DriverPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/customers/secretaries/departments/vehicles" element={<VehiclePage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/customers/customer-accesses" element={<AccessPage isHiddenMenu={isHiddenMenu} />} />

            <Route path="/secretaries" element={<SecretaryPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/departments" element={<DepartmentPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/drivers" element={<DriverPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/vehicles" element={<VehiclePage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/devices" element={<DevicePage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/identifiers" element={<IdentifierPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/commands" element={<CommandPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/accesses" element={<AccessPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/system-config" element={<SettingsPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/user-profile" element={<ProfilePage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/reports" element={<ReportPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/help-desk" element={<CustomerHelpPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="/logs" element={<LogListPage isHiddenMenu={isHiddenMenu} />} />
            <Route path="*" element={<NotFoundPage />} />
        </Routes>
    </>
};

const sidebarMenus = [
    { text: "Geral", icon: <LibraryAddOutlined style={{ marginRight: 5 }} />, route: "/", id: 1 },
    { text: "Sístema", icon: <SettingsOutlined style={{ marginRight: 5 }} />, route: "groups", id: 2 }
];

const sidebarManagerRecordsItems = [
    { text: "Início", icon: <DashboardCustomizeOutlined />, route: "/", id: 0, menuId: 1, tour: "Painel com os números gerais da plataforma." },
    { text: "Rastreamento", icon: <MapOutlined />, route: "/tracker", id: 1, menuId: 1, tour: "Esta tela: acompanhe os veículos de um cliente no mapa." },
    { text: "Dispositivos", icon: <TapAndPlayOutlined />, route: "devices", id: 10, menuId: 1, tour: "Rastreadores cadastrados e instalados nos veículos." },
    { text: "Identificadores", icon: <PinOutlined />, route: "identifiers", id: 11, menuId: 1, tour: "Identificadores dos motoristas usados nos veículos." },
    { text: "Comandos", icon: <TouchAppOutlined />, route: "commands", id: 12, menuId: 1, tour: "Comandos que podem ser enviados aos rastreadores." },

    { text: "Clientes", icon: <Diversity2Outlined />, route: "customers", id: 6, menuId: 1, tour: "Cadastro dos clientes e dos seus parâmetros." },
    { text: "Secretarias", icon: <LocationCityOutlined />, route: "secretaries", id: 7, menuId: 1, tour: "Secretarias de cada cliente." },
    { text: "Departamentos", icon: <ReduceCapacityOutlined />, route: "departments", id: 8, menuId: 1, tour: "Departamentos de cada secretaria." },
    { text: "Veículos", icon: <DirectionsCarFilledOutlined />, route: "vehicles", id: 9, menuId: 1, tour: "Cadastro dos veículos e dos seus parâmetros." },
    { text: "Motoristas", icon: <HailOutlined />, route: "drivers", id: 4, menuId: 1, tour: "Cadastro dos motoristas e dos seus identificadores." },
];

const sidebarManagerConfigsItems = [
    { text: "Acessos", icon: <BadgeOutlined />, route: "accesses", id: 13, menuId: 2, tour: "Usuários e perfis de acesso." },
    { text: "Relatórios", icon: <AssessmentOutlined />, route: "reports", id: 15, menuId: 2, tour: "Relatórios de posições, viagens, eventos e mais." },
    { text: "Suporte ao cliente", icon: <ContactSupportOutlined />, route: "help-desk", id: 16, menuId: 2, tour: "Chamados abertos pelos clientes." },
    { text: "Logs do sistema", icon: <HistoryEduOutlined />, route: "logs", id: 23, menuId: 2, tour: "Histórico das ações feitas no sistema." }
];

const footerItems = [
    { text: "Perfil", icon: <PersonOutlineOutlined />, route: "user-profile", id: 31 },
    { text: "Sair", icon: <LogoutOutlined />, route: "out", id: 32 }
];

const vehicleAlertCustomerSummaryDefault: VehicleAlertCustomerSummaryType = {
    customerId: -1,
    total: 0,
    critical: 0,
    warning: 0,
    vehicles: [],
};

const driverAlertCustomerSummaryDefault: DriverAlertCustomerSummaryType = {
    customerId: -1,
    total: 0,
    critical: 0,
    warning: 0,
    alerts: [],
};

const introTourSteps = buildIntroTourSteps("manager", [...sidebarManagerRecordsItems, ...sidebarManagerConfigsItems]);

const PrivateManagerApp = () => {
    const {
        mode,
        toggleColorMode,
        sidebarFontSize,
        increaseSidebarFontSize,
        decreaseSidebarFontSize,
    } = useThemeMode();
    // atoms
    const getCurrentUser = useRecoilValue<UserType>(userAtom);
    const isTechnician = getCurrentUser.accessProfile.id === Number(PROFILE_ACESSES.TECHNICIAN);

    const selectedCustomerToManagerMap = useRecoilValue<SelectedParametersSimpleType>(
        selectedCustomerToManagerMapAtom
    );

    const setSelectedCustomerToManagerMap = useSetRecoilState<SelectedParametersSimpleType>(
        selectedCustomerToManagerMapAtom
    );

    // cookies
    const [cookies, setCookies, removeCookies] = useCookies(["selectedParameters", "token", "oldSelectedParameters", "oldToken"]);

    // functionalities states
    const [hideMenu, setHideMenu] = useState<boolean>(true);
    const [hideMenuEvents, setHideMenuEvents] = useState<boolean>(true);
    const [hasParameters, setHasParameters] = useState<boolean>(true);

    // const [isOnline, setIsOnline] = useState<boolean>(true);
    // const [validationText, setTextValidation] = useState<string>("");
    // const [isFieldsValid, setFieldsIsValid] = useState<boolean>(true);
    // const [isToastVisible, setIsToastVisible] = useState(false);
    // const [statusMessage, setStatusMessage] = useState<"warn" | "success" | "info" | "error" | undefined>("warn");

    // const [showGeofences, setShowGeofences] = useState<boolean>(false);
    const [showCarsFilter, setShowCarFilter] = useState<boolean>(false);
    const [showMapChanger, setShowMapChanger] = useState<boolean>(false);
    const [showMapSearch, setShowMapSearch] = useState<boolean>(false);
    const [canShareTransparencyPortal, setCanShareTransparencyPortal] = useState<boolean>(false);

    const [isFixedMenu, setIsFixedMenu] = useState<boolean>(false);

    // mesma regra que exibe o menu Rastreamento (onde se escolhe qualquer cliente):
    // visualizar Rastreamento ou Clientes
    const canViewTracking = getCurrentUser.permissions.some(
        (permission) => permission.canView && [Number(MENUS_ITENS.TRACKING), Number(MENUS_ITENS.CUSTOMERS)].includes(permission.optionItem.id)
    );
    const selectedCustomerId = selectedCustomerToManagerMap.customerId;

    // exibe o botão do portal da transparência quando o cliente selecionado usa o link
    useEffect(() => {
        setCanShareTransparencyPortal(false);
        if (!canViewTracking || selectedCustomerId < 1) return;

        let active = true;
        const token = cookies.token || sessionStorage.getItem("token") || "";
        findTransparencyPortalLinkAvailable(token, selectedCustomerId)
            .then(({ data }) => active && setCanShareTransparencyPortal(data.available))
            .catch(() => active && setCanShareTransparencyPortal(false));

        return () => {
            active = false;
        };
    }, [canViewTracking, selectedCustomerId, cookies.token]);
    const [loading, setLoading] = useState<boolean>(false);
    const [openSystemMenu, setOpenSystemMenu] = useState<boolean>(false);
    const [vehicleAlerts, setVehicleAlerts] = useState<VehicleAlertCustomerSummaryType>(
        vehicleAlertCustomerSummaryDefault
    );
    const [driverAlerts, setDriverAlerts] = useState<DriverAlertCustomerSummaryType>(
        driverAlertCustomerSummaryDefault
    );
    const [alertsError, setAlertsError] = useState<boolean>(false);

    // refs
    const toastRef = useRef<Toast>(null);
    const alertsInitializedRef = useRef<boolean>(false);
    const knownCriticalAlertsRef = useRef<Set<string>>(new Set());
    const alertScopeRef = useRef<string>("");
    const alertsRequestVersionRef = useRef<number>(0);
    const navigate = useNavigate();
    const location = useLocation();

    // No administrativo o tour está sempre ativo; aparece no rastreamento depois de escolher o cliente.
    const introTour = useIntroTour({
        userId: getCurrentUser.id,
        enabled: hasParameters && !loading && location.pathname === "/tracker" && selectedCustomerId > 0,
        steps: introTourSteps,
        setMenuOpen: (open) => {
            setHideMenu(!open);
            if (open) setOpenSystemMenu(true);
        },
    });
    const { running: introTourRunning, restart: restartIntroTour } = introTour;

    const userMenus = useMemo(() => [...new Map(getCurrentUser.permissions.flatMap((item) => item.optionItem.option).map((item: any) => [item.id, item])).values()], [getCurrentUser.permissions]);
    const userMenusItens = useMemo(() => getCurrentUser.permissions.flatMap(((item) => { if (item.canView) return item.optionItem })), [getCurrentUser.permissions]);

    const goToRoute = useCallback(
        async (path: string, state?: any) => {
            const hasConection: boolean = window.navigator.onLine;
            if (hasConection) {
                navigate(path, { state: state });
            } else {
                // setIsOnline(false);
            }
        },
        [navigate]
    );

    const onSignOut = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const oldToken: string = cookies.oldToken;
        const oldParameters: SelectedParametersType = cookies.oldSelectedParameters;

        if (token) {
            setLoading(true);
            try {
                if (oldToken) {
                    setCookies("token", oldToken);
                    setCookies("selectedParameters", oldParameters);

                    removeCookies("oldToken");
                    removeCookies("oldSelectedParameters");
                    localStorage.removeItem("impersonating");

                    goToRoute("/");
                } else {
                    try {
                        await logoutUser(getCurrentUser.id, token);
                        removeCookies("token");
                        removeCookies("selectedParameters");
                    } catch (error: any) {
                        console.log("Erro ao deslogar:", error.message);
                    }
                }
            } catch (error: any) {
                console.log(error.message);
            } finally {
                setTimeout(() => {
                    window.location.reload();
                }, 2000);
            }
        }
    }, [cookies.token, cookies.oldSelectedParameters, cookies.oldToken, setCookies, removeCookies, goToRoute, getCurrentUser.id]);

    const getItemPermission = useCallback((id: number) => {
        return getCurrentUser.permissions.find((permission) => {
            if (permission.optionItem.id === id) {
                const { optionItem, ...rest } = permission;
                return rest;
            };
        });
    }, [getCurrentUser.permissions]);

    useEffect(() => {
        if (location.pathname !== "/tracker") return;

        const permissions = {
            tracker: getItemPermission(Number(MENUS_ITENS.TRACKING)),
            commands: getItemPermission(Number(MENUS_ITENS.COMMANDS)),
        };
        if (JSON.stringify(location.state) === JSON.stringify(permissions)) return;

        navigate("/tracker", { state: permissions, replace: true });
    }, [getItemPermission, location.pathname, location.state, navigate]);

    const getSelectedParameters = useCallback(async () => {
        const parameters = cookies.selectedParameters;
        setLoading(true);

        if (!!parameters) {
            setHasParameters(true);
        } else {
            setHasParameters(false);
        }
        setTimeout(() => {
            setLoading(false);
        }, 2000);
    }, [cookies.selectedParameters]);

    useEffect(() => {
        getSelectedParameters();
    }, [getSelectedParameters]);

    const getAlerts = useCallback(async () => {
        const token: string = cookies.token || sessionStorage.getItem("token");
        const customerId = selectedCustomerToManagerMap.customerId;
        const departmentId = selectedCustomerToManagerMap.departmentId;
        const scope = `${customerId}:${departmentId ?? -1}`;
        const requestVersion = ++alertsRequestVersionRef.current;

        if (!token || !customerId || customerId < 1) {
            alertScopeRef.current = "";
            alertsInitializedRef.current = false;
            knownCriticalAlertsRef.current = new Set();
            setVehicleAlerts(vehicleAlertCustomerSummaryDefault);
            setDriverAlerts(driverAlertCustomerSummaryDefault);
            setAlertsError(false);
            return;
        }

        if (alertScopeRef.current !== scope) {
            alertScopeRef.current = scope;
            alertsInitializedRef.current = false;
            knownCriticalAlertsRef.current = new Set();
            setVehicleAlerts(vehicleAlertCustomerSummaryDefault);
            setDriverAlerts(driverAlertCustomerSummaryDefault);
            setAlertsError(false);
        }

        try {
            const [vehicleResponse, driverResponse] = await Promise.all([
                findAllVehicleAlerts(token, customerId, departmentId).catch((error) => {
                    console.log(error);
                    return null;
                }),
                findAllDriverAlerts(token, customerId, departmentId).catch((error) => {
                    console.log(error);
                    return null;
                }),
            ]);
            if (alertsRequestVersionRef.current !== requestVersion) return;

            const vehicleSummary = vehicleResponse?.data as VehicleAlertCustomerSummaryType | undefined;
            const driverSummary = driverResponse?.data as DriverAlertCustomerSummaryType | undefined;
            const currentCriticalAlerts = new Map<string, string>();
            vehicleSummary?.vehicles.forEach((vehicle) => {
                vehicle.alerts
                    .filter((alert) => alert.severity === "CRITICAL")
                    .forEach((alert) => {
                        const key = [
                            "VEHICLE",
                            vehicle.vehicleId,
                            alert.code,
                            alert.sourceId,
                            alert.dueDate,
                            alert.dueOdometer,
                        ].join(":");
                        currentCriticalAlerts.set(
                            key,
                            `${vehicle.vehicleName} - ${vehicle.vehiclePlate}: ${alert.title}`
                        );
                    });
            });

            driverSummary?.alerts
                .filter((alert) => alert.severity === "CRITICAL")
                .forEach((alert) => {
                    const key = [
                        "DRIVER",
                        alert.driverId,
                        alert.code,
                        alert.dueDate,
                    ].join(":");
                    currentCriticalAlerts.set(key, `${alert.driverName}: ${alert.title}`);
                });

            if (alertsInitializedRef.current) {
                const newCriticalAlerts = [...currentCriticalAlerts.entries()]
                    .filter(([key]) => !knownCriticalAlertsRef.current.has(key));
                if (newCriticalAlerts.length > 0) {
                    toastRef.current?.show({
                        severity: "warn",
                        summary: "Novo alerta crítico",
                        detail: newCriticalAlerts.length === 1
                            ? newCriticalAlerts[0][1]
                            : `${newCriticalAlerts.length} novos alertas críticos requerem atenção.`,
                        life: 8000,
                    });
                }
            }

            const retainedKeys = [...knownCriticalAlertsRef.current].filter((key) =>
                (!vehicleSummary && key.startsWith("VEHICLE:")) ||
                (!driverSummary && key.startsWith("DRIVER:"))
            );
            knownCriticalAlertsRef.current = new Set([...retainedKeys, ...currentCriticalAlerts.keys()]);
            if (vehicleSummary && driverSummary) alertsInitializedRef.current = true;
            if (vehicleSummary) setVehicleAlerts(vehicleSummary);
            if (driverSummary) setDriverAlerts(driverSummary);
            setAlertsError(!vehicleSummary || !driverSummary);
        } catch (error) {
            console.log(error);
            if (alertsRequestVersionRef.current === requestVersion) {
                setAlertsError(true);
            }
        }
    }, [
        cookies.token,
        selectedCustomerToManagerMap.customerId,
        selectedCustomerToManagerMap.departmentId,
    ]);

    useEffect(() => {
        getAlerts();
        const intervalId = window.setInterval(getAlerts, 900000);
        const handleVisibilityChange = () => {
            if (document.visibilityState === "visible") getAlerts();
        };
        document.addEventListener("visibilitychange", handleVisibilityChange);

        return () => {
            window.clearInterval(intervalId);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            alertsRequestVersionRef.current += 1;
        };
    }, [getAlerts]);

    const renderSidebarItems = useCallback((
        items: Array<{
            id: number;
            text: string;
            icon: JSX.Element;
            route: string;
        }>) => {
        return items.map((item: any) => {
            const itemRoute = item.route.startsWith("/")
                ? item.route
                : `/${item.route}`;
            const isActive = itemRoute === "/"
                ? window.location.pathname === "/"
                : window.location.pathname.startsWith(itemRoute);

            return <ListItem
                className="menuItem-option tw-my-0.5 tw-overflow-hidden tw-rounded-lg tw-transition-colors tw-duration-200 tw-ease-gtr-smooth"
                key={item.text}
                disablePadding
                id={item.id}
                {...tourAnchor(menuTourId(item.id))}
                sx={{
                    color: "#ffff",
                    backgroundColor: isActive ? "#09414A" : "transparent",
                    borderRadius: 2,
                    boxShadow: isActive ? "inset 3px 0 0 #00B700" : "none",
                    transition: "background-color 200ms ease, box-shadow 200ms ease",
                    "&:hover": {
                        backgroundColor: isActive ? "#09414A" : "rgba(255, 255, 255, 0.10)",
                    },
                }}
            >
                <ListItemButton
                    className="tw-group !tw-min-h-10 !tw-rounded-lg !tw-px-3 !tw-py-2 tw-font-prometo tw-transition-[background-color,transform] tw-duration-200 tw-ease-gtr-smooth hover:tw-translate-x-0.5 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/70"
                    sx={{ color: "#ffff" }}
                    onClick={() => {
                        if (item.route === "out") {
                            setLoading(true);
                            onSignOut();
                        } else {
                            const permissions = getItemPermission(item.id);
                            const state = item.id === Number(MENUS_ITENS.TRACKING)
                                ? { tracker: permissions, commands: getItemPermission(Number(MENUS_ITENS.COMMANDS)) }
                                : permissions;
                            goToRoute(item.route, state);
                            setHideMenu(true);
                        }
                    }}
                >
                    <ListItemIcon
                        className="!tw-min-w-9 !tw-text-white tw-transition-transform tw-duration-200 group-hover:tw-scale-105"
                        sx={{
                            minWidth: 36,
                            color: "#ffff",
                            "& .MuiSvgIcon-root": { color: "#ffff", fill: "currentColor" },
                        }}
                    >
                        {item.icon}
                    </ListItemIcon>
                    <ListItemText
                        primary={item.text}
                        primaryTypographyProps={{
                            color: "#ffff",
                            fontFamily: "Prometo",
                            fontSize: 14,
                            fontWeight: isActive ? 700 : 400,
                        }}
                    />
                </ListItemButton>
            </ListItem>
        });
    }, [goToRoute, onSignOut, getItemPermission]);

    const renderSidebarWithPermissionsItems = useCallback(
        (
            menus: Array<{
                id: number;
                text: string;
                icon: JSX.Element;
            }>,
            items: Array<{
                id: number;
                text: string;
                menuId: number;
                icon: JSX.Element;
                route: string;
            }>
        ) => {
            const renderMenuList = menus.filter((menu) => {
                return userMenus.find((it) => {
                    if (menu.id === it.id) {
                        return menu
                    }
                });
            });

            const renderMenuItens = items.filter((item) => {
                return userMenusItens.find((it) => {
                    if ((item.menuId === it?.option.id && item.id === it.id) || (!isTechnician && item.id === Number(MENUS_ITENS.INITIALPAGE)) || (!isTechnician && it?.id === Number(MENUS_ITENS.CUSTOMERS) && item.id === Number(MENUS_ITENS.TRACKING))) {
                        return item
                    }
                });
            });

            return (
                <Box
                    className="menu-options tw-min-h-0 tw-flex-1 tw-overflow-y-auto tw-px-2 tw-pb-16 tw-font-prometo"
                    sx={{
                        minHeight: 0,
                        flex: 1,
                        overflowY: "auto",
                        px: 1,
                        pb: 8,
                        scrollbarWidth: "none",
                        msOverflowStyle: "none",
                        "&::-webkit-scrollbar": { display: "none" },
                    }}
                >
                    {renderMenuList.map((menu, index) => (
                        <Box key={index} className="tw-py-1">
                            {renderMenuItens.some((items) => items.menuId === menu.id) && (
                                <ListItemButton
                                    className="!tw-min-h-10 !tw-rounded-lg !tw-px-3 tw-transition-colors tw-duration-200 hover:!tw-bg-white/10 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/70"
                                    onClick={() => menu.id === 2 ? setOpenSystemMenu(!openSystemMenu) : null}
                                    sx={{
                                        minHeight: 40,
                                        padding: 1,
                                        color: "#ffff",
                                        '&:hover': { background: 'rgba(255, 255, 255, 0.08)' }
                                    }}
                                >
                                    <ListItemIcon sx={{ color: "#ffff", minWidth: 35, "& .MuiSvgIcon-root": { color: "#ffff" } }}>{menu.icon}</ListItemIcon>
                                    <ListItemText
                                        primary={menu.text}
                                        primaryTypographyProps={{
                                            color: "#ffff",
                                            fontFamily: "Prometo",
                                            fontSize: 12,
                                            fontWeight: "bold",
                                            letterSpacing: "0.08em",
                                            textTransform: "uppercase",
                                        }}
                                    />
                                    {menu.id === 2 ? (openSystemMenu ? <ExpandLess sx={{ color: "#ffff" }} /> : <ExpandMore sx={{ color: "#ffff" }} />) : null}
                                </ListItemButton>
                            )}
                            <Divider className="!tw-border-white/20" sx={{ borderColor: "rgba(255, 255, 255, 0.20)" }} />
                            {menu.id === 2 ? (
                                <Collapse in={openSystemMenu} timeout="auto" unmountOnExit>
                                    <List component="div" disablePadding>
                                        {renderSidebarItems(
                                            renderMenuItens.filter((items) => items.menuId === menu.id)
                                        )}
                                    </List>
                                </Collapse>
                            ) : (
                                renderSidebarItems(
                                    renderMenuItens.filter((items) => items.menuId === menu.id)
                                )
                            )}
                        </Box>
                    ))}
                </Box>
            );
        },
        [renderSidebarItems, userMenus, userMenusItens, openSystemMenu, isTechnician]
    );

    const totalAlerts = vehicleAlerts.total + driverAlerts.total;
    const criticalAlerts = vehicleAlerts.critical + driverAlerts.critical;
    const warningAlerts = vehicleAlerts.warning + driverAlerts.warning;

    const renderMapOptions = useMemo(() => {
        return (
            <Box>
                {!isFixedMenu && (
                    <Box
                        className="tw-shadow-lg tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                        sx={{
                            position: "absolute",
                            zIndex: 99999,
                            left: 10,
                            top: 10,
                            border: "1px solid rgba(255, 255, 255, 0.16)",
                            borderRadius: 2.5,
                            backgroundImage: "linear-gradient(135deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                            boxShadow: "0 8px 24px rgba(9, 65, 74, 0.22)",
                            visibility: hideMenuEvents ? "visible" : "hidden",
                            opacity: hideMenuEvents ? 1 : 0,
                            transform: hideMenuEvents ? "translateY(0)" : "translateY(-6px)",
                            pointerEvents: hideMenuEvents ? "auto" : "none",
                        }}
                    >
                        <Tooltip title="Ocultar ou mostrar menu" arrow placement="right">
                            <IconButton
                                {...tourAnchor("menu-toggle")}
                                aria-label="Ocultar ou mostrar menu"
                                className="!tw-h-11 !tw-w-11 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                onClick={() => {
                                    setHideMenu(!hideMenu);
                                    setHideMenuEvents(true);
                                }}
                            >
                                {hideMenu ? (
                                    <MenuOutlined style={{ color: "#ffff" }} />
                                ) : (
                                    <MenuOpenOutlined style={{ color: "#ffff" }} />
                                )}
                            </IconButton>
                        </Tooltip>
                    </Box>
                )}

                <Box
                    className="event-drawer-button tw-shadow-lg tw-backdrop-blur-md"
                    sx={{
                        position: "absolute",
                        zIndex: 99999,
                        right: 10,
                        top: 10,
                        border: "1px solid rgba(255, 255, 255, 0.16)",
                        borderRadius: 2.5,
                        backgroundImage: "linear-gradient(135deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                        boxShadow: "0 8px 24px rgba(9, 65, 74, 0.22)",
                    }}
                >
                    <Tooltip title="Visualizar alertas" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-alerts")}
                            aria-label="Visualizar alertas"
                            className="!tw-h-11 !tw-w-11 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                            onClick={() => {
                                setHideMenuEvents(!hideMenuEvents);
                                if (!isFixedMenu) setHideMenu(true);
                            }}
                        >
                            <Badge
                                badgeContent={totalAlerts}
                                color={criticalAlerts > 0 ? "error" : "warning"}
                                max={99}
                                sx={{
                                    "& .MuiBadge-badge": {
                                        backgroundColor: criticalAlerts > 0 ? "#d32f2f" : "#ed6c02",
                                        color: "#fff",
                                        fontWeight: "bold",
                                        boxShadow: "0 0 0 2px rgb(0, 63, 74)",
                                    },
                                }}
                            >
                                {hideMenuEvents ? (
                                    <NotificationsActiveOutlined
                                        sx={{ color: criticalAlerts > 0 ? "#ff5252" : warningAlerts > 0 ? "#ffb74d" : "#ffff" }}
                                    />
                                ) : (
                                    <NotificationsNoneOutlined
                                        sx={{ color: criticalAlerts > 0 ? "#ff5252" : warningAlerts > 0 ? "#ffb74d" : "#ffff" }}
                                    />
                                )}
                            </Badge>
                        </IconButton>
                    </Tooltip>
                </Box>

                <Box
                    aria-hidden={!hideMenuEvents}
                    className="tw-shadow-xl tw-backdrop-blur-md tw-transition-all tw-duration-300 tw-ease-gtr-smooth"
                    sx={{
                        position: "absolute",
                        zIndex: 99999,
                        right: 10,
                        top: 65,
                        display: location.pathname.endsWith("/tracker") ? "flex" : "none",
                        flexDirection: "column",
                        gap: 0.5,
                        padding: 0.5,
                        border: "1px solid rgba(255, 255, 255, 0.16)",
                        borderRadius: 3,
                        backgroundImage: "linear-gradient(180deg, rgba(0, 108, 119, 0.96), rgba(9, 65, 74, 0.96))",
                        boxShadow: "0 12px 32px rgba(9, 65, 74, 0.24)",
                        visibility: hideMenuEvents ? "visible" : "hidden",
                        opacity: hideMenuEvents ? 1 : 0,
                        transform: hideMenuEvents ? "translateX(0)" : "translateX(8px)",
                        pointerEvents: hideMenuEvents ? "auto" : "none",
                        "& .MuiIconButton-root": {
                            width: 40,
                            height: 40,
                            color: "#fff",
                            borderRadius: 2,
                            transition: "background-color 180ms ease, color 180ms ease, transform 180ms ease",
                        },
                        "& .MuiIconButton-root:hover": {
                            backgroundColor: "rgba(255, 255, 255, 0.13)",
                            transform: "translateX(-2px)",
                        },
                    }}
                >
                    <Tooltip title="Abrir rastreamento em nova aba" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-new-tab")}
                            aria-label="Abrir rastreamento em nova aba"
                            onClick={() => {
                                window.open(location.pathname, "_blank");
                            }}
                        >
                            <QueuePlayNextOutlined style={{ color: "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Selecionar cliente" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-select-customer")}
                            aria-label="Selecionar cliente"
                            onClick={() => {
                                setSelectedCustomerToManagerMap({
                                    customerId: -1,
                                    departmentId: -1,
                                    managerId: -1,
                                    secretaryId: -1,
                                    userId: -1,
                                    isViewingAll: false,
                                    name: "",
                                    reducedName: null
                                });
                            }}
                        >
                            <DisplaySettingsOutlined style={{ color: "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Filtrar veículos no mapa" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-filter")}
                            aria-label="Filtrar veículos no mapa"
                            onClick={() => {
                                setShowCarFilter(!showCarsFilter);
                            }}
                        >
                            <TuneOutlined sx={{ color: showCarsFilter ? "#00b700" : "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Selecionar mapa" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-layers")}
                            aria-label="Selecionar mapa"
                            onClick={() => {
                                setShowMapChanger(!showMapChanger);
                            }}
                        >
                            <LayersOutlined sx={{ color: showMapChanger ? "#00b700" : "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Pesquisar endereço" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-search")}
                            aria-label="Pesquisar endereço"
                            onClick={() => {
                                setShowMapSearch(!showMapSearch);
                            }}
                        >
                            <SearchOutlined sx={{ color: showMapSearch ? "#00b700" : "#ffff" }} />
                        </IconButton>
                    </Tooltip>

                    {canShareTransparencyPortal && (
                        <TransparencyPortalLinkButton key={selectedCustomerId} customerId={selectedCustomerId} />
                    )}

                    <Tooltip title="Ver o tour de introdução" arrow placement="left">
                        <IconButton
                            {...tourAnchor("map-tour-replay")}
                            aria-label="Ver o tour de introdução"
                            onClick={restartIntroTour}
                        >
                            <HelpOutlineOutlined sx={{ color: "#ffff" }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Box>
        );
    }, [
        // showGeofences,
        warningAlerts,
        hideMenuEvents,
        hideMenu,
        location.pathname,
        setSelectedCustomerToManagerMap,
        totalAlerts,
        criticalAlerts,
        showCarsFilter,
        showMapChanger,
        showMapSearch,
        isFixedMenu,
        canShareTransparencyPortal,
        selectedCustomerId,
        restartIntroTour
    ]);

    const IOSSwitch = useMemo(() => styled((props: SwitchProps) => (
        <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
    ))(({ theme }) => ({
        width: 42,
        height: 26,
        padding: 0,
        '& .MuiSwitch-switchBase': {
            padding: 0,
            margin: 2,
            transitionDuration: '300ms',
            '&.Mui-checked': {
                transform: 'translateX(16px)',
                color: '#fff',
                '& + .MuiSwitch-track': {
                    backgroundColor: '#65C466',
                    opacity: 1,
                    border: 0,
                    ...theme.applyStyles('dark', {
                        backgroundColor: '#2ECA45',
                    }),
                },
                '&.Mui-disabled + .MuiSwitch-track': {
                    opacity: 0.5,
                },
            },
            '&.Mui-focusVisible .MuiSwitch-thumb': {
                color: '#33cf4d',
                border: '6px solid #fff',
            },
            '&.Mui-disabled .MuiSwitch-thumb': {
                color: theme.palette.grey[100],
                ...theme.applyStyles('dark', {
                    color: theme.palette.grey[600],
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.7,
                ...theme.applyStyles('dark', {
                    opacity: 0.3,
                }),
            },
        },
        '& .MuiSwitch-thumb': {
            boxSizing: 'border-box',
            width: 22,
            height: 22,
        },
        '& .MuiSwitch-track': {
            borderRadius: 26 / 2,
            backgroundColor: '#E9E9EA',
            opacity: 1,
            transition: theme.transitions.create(['background-color'], {
                duration: 500,
            }),
            ...theme.applyStyles('dark', {
                backgroundColor: '#39393D',
            }),
        },
    })), []);

    const template = useMemo(() => {
        return (
            <>
                {renderMapOptions}
                <Drawer
                    className="event-drawer"
                    anchor="right"
                    open={!hideMenuEvents}
                    onClose={() => setHideMenuEvents(true)}
                    PaperProps={{
                        className:
                            "!tw-w-[calc(100vw-1.5rem)] sm:!tw-w-80 !tw-overflow-hidden !tw-bg-gtr-sidebar !tw-text-white tw-shadow-gtr-sidebar tw-transition-transform tw-duration-300 tw-ease-gtr-smooth dark:!tw-bg-slate-950",
                    }}
                    sx={{
                        width: { xs: "calc(100vw - 24px)", sm: 320 },
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: { xs: "calc(100vw - 24px)", sm: 320 },
                            color: "#ffff",
                            backgroundImage: mode === "dark"
                                ? "linear-gradient(to bottom, #0f172a, #020617)"
                                : "linear-gradient(to right, #006C77 , #09414A)",
                            boxSizing: "border-box",
                            display: "flex",
                            flexDirection: "column",
                            overflow: "hidden",
                        },
                    }}
                >
                    <Toolbar
                        className="!tw-min-h-16 !tw-flex-none !tw-border-b !tw-border-white/20 !tw-px-4"
                        sx={{
                            display: "flex",
                            justifyContent: "space-between",
                            flexShrink: 0,
                            borderBottom: "1px solid rgba(255, 255, 255, 0.2)",
                        }}
                    >
                        <Box className="tw-flex tw-items-center tw-gap-2">
                            <NotificationsActiveOutlined />
                            <Typography variant="h6" component="h2" sx={{ fontFamily: "Prometo", fontWeight: 700 }}>
                                Alertas
                            </Typography>
                        </Box>
                        <Box className="tw-flex tw-h-8 tw-min-w-8 tw-items-center tw-justify-center tw-rounded-full tw-bg-white/10 tw-px-2">
                            <Typography variant="caption" sx={{ fontFamily: "Prometo", fontWeight: 700 }}>{totalAlerts}</Typography>
                        </Box>
                    </Toolbar>
                    <Box
                        className="event-drawer-content tw-scroll-smooth tw-bg-slate-100/95 dark:tw-bg-slate-950"
                        sx={{
                            padding: 1.5,
                            flex: 1,
                            minHeight: 0,
                            overflowY: "auto",
                            display: "flex",
                            flexDirection: "column",
                            gap: 1.5,
                            backgroundColor: mode === "dark" ? "#020617" : "rgba(241,245,249,0.96)",
                            scrollbarWidth: "thin",
                            scrollbarColor: "#006C77 transparent",
                        }}
                    >
                        {selectedCustomerToManagerMap.customerId < 1 ? (
                            <Typography className="tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-text-slate-500" variant="body2" sx={{ textAlign: "center", padding: 2 }}>
                                Selecione um cliente no rastreamento para visualizar os alertas.
                            </Typography>
                        ) : !alertsError && totalAlerts === 0 && (
                            <Typography className="tw-rounded-xl tw-border tw-border-slate-200 tw-bg-white tw-p-4 tw-text-slate-500" variant="body2" sx={{ textAlign: "center", padding: 2 }}>
                                Nenhum alerta pendente.
                            </Typography>
                        )}
                        {alertsError && (
                            <Typography className="tw-rounded-xl tw-border tw-border-red-100 tw-bg-red-50 tw-p-3 tw-text-red-700" variant="body2" sx={{ textAlign: "center", padding: 1.5 }}>
                                Não foi possível atualizar todos os alertas. A consulta será repetida automaticamente.
                            </Typography>
                        )}
                        {vehicleAlerts.total > 0 && (
                            <>
                                <Typography className="tw-px-1 tw-text-slate-700" variant="subtitle2" sx={{ fontWeight: 700 }}>
                                    Veículos
                                </Typography>
                                {vehicleAlerts.vehicles.flatMap((vehicle) =>
                                    vehicle.alerts.map((alert) => (
                                        <VehicleAlertCard
                                            key={`${vehicle.vehicleId}-${alert.code}-${alert.sourceId}-${alert.dueDate}-${alert.dueOdometer}`}
                                            vehicle={vehicle}
                                            alert={alert}
                                        />
                                    ))
                                )}
                            </>
                        )}
                        {driverAlerts.total > 0 && (
                            <>
                                {vehicleAlerts.total > 0 && (
                                    <Divider sx={{ borderColor: "rgba(15, 23, 42, 0.10)", marginY: 0.5 }} />
                                )}
                                <Typography className="tw-px-1 tw-text-slate-700" variant="subtitle2" sx={{ fontWeight: 700 }}>
                                    Motoristas
                                </Typography>
                                {driverAlerts.alerts.map((alert) => (
                                    <DriverAlertCard key={alert.code} alert={alert} />
                                ))}
                            </>
                        )}
                    </Box>
                </Drawer>
                <Drawer
                    open={isFixedMenu ? true : !hideMenu}
                    // O foco preso no menu brigaria com o foco do balão do tour.
                    ModalProps={{ disableEnforceFocus: introTourRunning }}
                    variant={isFixedMenu ? "persistent" : "temporary"}
                    onClose={() => setHideMenu(!hideMenu)}
                    hideBackdrop={isFixedMenu ? true : false}
                    anchor={"left"}
                    className="menu-drawer"
                    PaperProps={{
                        className:
                            "!tw-w-[86vw] !tw-max-w-[300px] sm:!tw-w-[280px] !tw-overflow-hidden !tw-bg-gtr-sidebar !tw-text-white tw-shadow-gtr-sidebar tw-transition-transform tw-duration-300 tw-ease-gtr-smooth",
                    }}
                    sx={{
                        width: { xs: "min(86vw, 300px)", sm: 280 },
                        flexShrink: 0,
                        "& .MuiDrawer-paper": {
                            width: { xs: "min(86vw, 300px)", sm: 280 },
                            color: "#ffff",
                            backgroundImage: "linear-gradient(to right, #006C77 , #09414A)",
                            boxShadow: "0 12px 36px rgba(0, 0, 0, 0.22)",
                            boxSizing: "border-box",
                            fontSize: "14px",
                            overflow: "hidden",
                            borderRight: "none",
                        }
                    }}
                >
                    <Box
                        component="aside"
                        className="gtr-sidebar tw-relative tw-flex tw-h-full tw-w-full tw-flex-col tw-overflow-hidden tw-font-prometo"
                        sx={{
                            "--gtr-sidebar-font-size": `${sidebarFontSize}px`,
                            position: "relative",
                            display: "flex",
                            flexDirection: "column",
                            width: "100%",
                            height: "100%",
                            overflow: "hidden",
                            fontFamily: "Prometo",
                        }}
                    >
                        <Toolbar
                            className="!tw-flex !tw-min-h-0 !tw-w-full !tw-flex-none !tw-flex-col !tw-items-stretch !tw-p-0"
                            sx={{
                                display: "flex",
                                flexDirection: "column",
                                alignItems: "stretch",
                                width: "100%",
                                minHeight: 0,
                                padding: 0,
                                backgroundImage: "linear-gradient(to right, #006C77 , #09414A)",
                            }}
                        >
                            <Box
                                className="tw-relative tw-flex tw-min-h-28 tw-items-center tw-justify-center tw-overflow-hidden tw-py-4"
                                sx={{
                                    position: "relative",
                                    display: "flex",
                                    justifyContent: "center",
                                    alignItems: "center",
                                    minHeight: 112,
                                    paddingY: 2,
                                    overflow: "hidden",
                                }}
                            >
                                <Box
                                    aria-hidden="true"
                                    className="tw-absolute tw-h-24 tw-w-24 tw-rounded-full tw-bg-cover tw-bg-center tw-opacity-70 tw-blur-[1px]"
                                    sx={{
                                        position: "absolute",
                                        width: 96,
                                        height: 96,
                                        borderRadius: "50%",
                                        backgroundImage: `url(${require("../../assets/files/maps-image.png")})`,
                                        backgroundPosition: "center",
                                        backgroundSize: "cover",
                                        filter: "blur(1px)",
                                        opacity: 0.7,
                                    }}
                                />
                                <Box
                                    className="tw-relative tw-flex tw-h-20 tw-w-20 tw-items-center tw-justify-center tw-overflow-hidden tw-rounded-full tw-border-0 tw-bg-gtr-teal-dark tw-shadow-xl"
                                    sx={{
                                        position: "relative",
                                        display: "flex",
                                        justifyContent: "center",
                                        alignItems: "center",
                                        width: 80,
                                        height: 80,
                                        overflow: "hidden",
                                        borderRadius: "50%",
                                        border: "none",
                                        backgroundColor: "#09414A",
                                        boxShadow: "0 10px 28px rgba(0, 0, 0, 0.24)",
                                    }}
                                >
                                    <AccountCircleOutlined sx={{ width: 64, height: 64, color: "#dbdbdb" }} />
                                    <Box
                                        component="img"
                                        src={require("../../assets/files/tracker.png")}
                                        alt="Imagem do usuário"
                                        onError={(event: any) => {
                                            event.currentTarget.style.display = "none";
                                        }}
                                        sx={{
                                            position: "absolute",
                                            inset: 0,
                                            width: "100%",
                                            height: "100%",
                                            objectFit: "cover",
                                        }}
                                    />
                                </Box>
                            </Box>

                            <Box
                                className="!tw-w-[86vw] !tw-max-w-[300px] sm:!tw-w-[280px] tw-bg-gtr-green tw-px-4 tw-py-3 tw-shadow-[0_-8px_24px_rgba(0,0,0,0.08)]"
                                sx={{
                                    width: { xs: "min(86vw, 300px)", sm: "280px" },
                                    minWidth: { xs: "min(86vw, 300px)", sm: "280px" },
                                    maxWidth: { xs: "min(86vw, 300px)", sm: "280px" },
                                    alignSelf: "stretch",
                                    flexShrink: 0,
                                    margin: 0,
                                    boxSizing: "border-box",
                                    paddingX: 2,
                                    paddingY: 1.5,
                                    backgroundColor: "#00B700",
                                    boxShadow: "0 -8px 24px rgba(0, 0, 0, 0.08)",
                                }}
                            >
                                <Box className="header-title" sx={{ display: "flex", justifyContent: "center", alignItems: "center", fontFamily: "Prometo" }}>
                                    <Typography
                                        className="element-on-header"
                                        style={{
                                            lineBreak: "anywhere",
                                            color: "#ffff",
                                            alignSelf: "center",
                                            justifySelf: "center",
                                            fontSize: "var(--gtr-sidebar-font-size, 12px)",
                                            fontWeight: 700,
                                            textAlign: "center",
                                            lineHeight: 1.25,
                                            overflowWrap: "anywhere",
                                        }}
                                    >{cookies.selectedParameters?.customer?.reducedName}</Typography>
                                </Box>
                                <Box className="header-actions" sx={{ display: "flex", justifyContent: "center", alignItems: "center", alignContent: "center", fontFamily: "Prometo", marginTop: 0.5 }}>
                                    <Tooltip title="Selecionar parâmetros" arrow placement="top">
                                        <IconButton
                                            aria-label="Selecionar parâmetros"
                                            className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                            onClick={() => {
                                                removeCookies("selectedParameters");
                                                goToRoute("/");
                                            }}
                                        >
                                            <ManageAccountsOutlined style={{ color: "#ffff" }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Perfil" arrow placement="top">
                                        <IconButton
                                            aria-label="Abrir perfil"
                                            className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                            onClick={() => { goToRoute("/user-profile"); }}
                                        >
                                            <PersonOutlineOutlined style={{ color: "#ffff" }} />
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title={mode === "dark" ? "Usar tema claro" : "Usar tema escuro"} arrow placement="top">
                                        <IconButton
                                            aria-label={mode === "dark" ? "Usar tema claro" : "Usar tema escuro"}
                                            className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                            onClick={toggleColorMode}
                                        >
                                            {mode === "dark" ? (
                                                <WbSunnyOutlined style={{ color: "#ffff" }} />
                                            ) : (
                                                <DarkModeOutlined style={{ color: "#ffff" }} />
                                            )}
                                        </IconButton>
                                    </Tooltip>
                                    <Tooltip title="Sair" arrow placement="top">
                                        <IconButton
                                            aria-label="Sair"
                                            className="!tw-mx-0.5 tw-transition-all tw-duration-200 tw-ease-gtr-smooth hover:!tw-bg-white/15 hover:tw-scale-105 focus-visible:tw-outline focus-visible:tw-outline-2 focus-visible:tw-outline-white/80"
                                            onClick={() => { onSignOut(); }}
                                        >
                                            <ExitToAppOutlined style={{ color: "#ffff" }} />
                                        </IconButton>
                                    </Tooltip>
                                </Box>
                                <Box
                                    role="group"
                                    aria-label="Tamanho da fonte do menu"
                                    className="tw-mt-1 tw-flex tw-items-center tw-justify-center tw-gap-1"
                                >
                                    <Tooltip title="Diminuir fonte do menu" arrow placement="bottom">
                                        <span>
                                            <IconButton
                                                aria-label="Diminuir fonte do menu"
                                                disabled={sidebarFontSize <= 12}
                                                onClick={decreaseSidebarFontSize}
                                                className="!tw-h-7 !tw-w-7 hover:!tw-bg-white/15"
                                                sx={{ color: "#fff", "&.Mui-disabled": { color: "rgba(255,255,255,0.42)" } }}
                                            >
                                                <span className="gtr-sidebar-font-control" aria-hidden="true">A−</span>
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                    <Typography component="span" aria-live="polite" sx={{ color: "#fff", minWidth: 34, textAlign: "center", fontWeight: 700 }}>
                                        {sidebarFontSize}px
                                    </Typography>
                                    <Tooltip title="Aumentar fonte do menu" arrow placement="bottom">
                                        <span>
                                            <IconButton
                                                aria-label="Aumentar fonte do menu"
                                                disabled={sidebarFontSize >= 16}
                                                onClick={increaseSidebarFontSize}
                                                className="!tw-h-7 !tw-w-7 hover:!tw-bg-white/15"
                                                sx={{ color: "#fff", "&.Mui-disabled": { color: "rgba(255,255,255,0.42)" } }}
                                            >
                                                <span className="gtr-sidebar-font-control" aria-hidden="true">A+</span>
                                            </IconButton>
                                        </span>
                                    </Tooltip>
                                </Box>
                            </Box>
                        </Toolbar>
                        {renderSidebarWithPermissionsItems(sidebarMenus, [...sidebarManagerConfigsItems, ...sidebarManagerRecordsItems])}
                        <Box className="menu-footer" style={{
                            position: "absolute",
                            bottom: 0,
                            right: 100,
                            borderRadius: 100,
                            margin: 10,
                        }}>
                            {false && <CardMedia
                                style={{
                                    height: 10,
                                    width: 10,
                                    objectFit: "contain"
                                }}
                                component="img"
                                alt="Imagem"
                                image={require("../../assets/files/gtf-white.png")}
                            />}
                        </Box>

                        <Box
                            className="menu-footer tw-absolute tw-bottom-3 tw-right-3 tw-z-10 tw-rounded-full tw-bg-black/10 tw-p-1 tw-backdrop-blur-sm"
                            sx={{
                                position: "absolute",
                                right: 12,
                                bottom: 12,
                                zIndex: 10,
                                padding: 0.5,
                                borderRadius: "50%",
                                backgroundColor: "rgba(0, 0, 0, 0.10)",
                                backdropFilter: "blur(4px)",
                            }}
                        >
                            <Tooltip title="Fixar o menu" arrow placement="left">
                                <IOSSwitch
                                    checked={isFixedMenu}
                                    onChange={(event) => {
                                        const checked = event.target.checked;
                                        setIsFixedMenu(checked);
                                    }}
                                    inputProps={{ 'aria-label': 'Fixar menu' }}
                                />
                            </Tooltip>
                        </Box>
                    </Box>
                </Drawer>
                <Box
                    style={{
                        width: "100vw",
                        display: "flex",
                        flexDirection: "column"
                    }}
                >
                    {!loading ? (
                        <Box>
                            <Toast ref={toastRef} position="center" style={{ position: "absolute" }} onShow={() => {
                                setTimeout(() => {
                                    // setTextValidation("");
                                    // setStatusMessage("warn");
                                    // setIsToastVisible(false);
                                }, 3500);
                            }} />
                            {(location.pathname === "/tracker" && selectedCustomerToManagerMap.customerId <= -1) &&
                                <SelectParametersModal onSend={() => {
                                    setHasParameters(true);
                                }}
                                    onClose={() => { }}
                                    handleChange={() => { }}
                                    fieldValue=""
                                    isVisible={true}
                                    loading={loading}
                                />}
                            {<PrivateRoutes isHiddenMenu={hideMenu || hideMenuEvents}
                                isFixedMenu={isFixedMenu}
                                isMenuOverlayOpen={!isFixedMenu && !hideMenu}
                                showGeofences={false}
                                showCarsFilter={showCarsFilter}
                                showMapChanger={showMapChanger}
                                showMapSearch={showMapSearch}
                                filterActions={[
                                    {
                                        name: "showCarsFilter",
                                        action: (value: boolean) => setShowCarFilter(value),
                                    },
                                    {
                                        name: "showMapChanger",
                                        action: (value: boolean) => setShowMapChanger(value),
                                    },
                                    {
                                        name: "showMapSearch",
                                        action: (value: boolean) => setShowMapSearch(value),
                                    },
                                ]} />}
                        </Box>
                    ) : (
                        <Box
                            style={{
                                width: "100%",
                                padding: 20,
                                display: "flex",
                                alignItems: "center",
                                flexDirection: "column",
                            }}
                        >
                            <div className="tracker-loading"><div className="ld-tracker">
                                <div></div><div></div><div></div>
                            </div></div>
                        </Box>
                    )}
                </Box>
            </>
        );
    }, [
        removeCookies,
        hideMenuEvents,
        cookies.selectedParameters?.customer?.reducedName,
        showCarsFilter,
        // showGeofences, 
        showMapChanger,
        showMapSearch,
        selectedCustomerToManagerMap.customerId,
        location.pathname,
        renderSidebarWithPermissionsItems,
        renderMapOptions,
        goToRoute,
        onSignOut,
        hideMenu,
        loading,
        isFixedMenu,
        vehicleAlerts,
        driverAlerts,
        totalAlerts,
        alertsError,
        IOSSwitch,
        mode,
        toggleColorMode,
        sidebarFontSize,
        increaseSidebarFontSize,
        decreaseSidebarFontSize,
        introTourRunning
    ]);

    return hasParameters && !loading ? (
        <>
            {template}
            {introTour.tour}
        </>
    ) : (
        <>
            {!loading ? (
                <SelectParametersModal
                    onSend={() => {
                        setHasParameters(true);
                    }}
                    onClose={() => { }}
                    handleChange={() => { }}
                    fieldValue=""
                    isVisible={true}
                    loading={loading}
                />
            ) : (
                <Box
                    style={{
                        marginTop: 2,
                        borderRadius: 5,
                        fontFamily: "Prometo",
                        height: 650,
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                    }}
                >
                    <div className="tracker-loading-main">
                        <div className="ld-tracker ld-tracker-main">
                            <div></div>
                            <div></div>
                            <div></div>
                        </div>
                    </div>
                </Box>
            )}
        </>
    );
};

export default PrivateManagerApp;
